import React from 'react';

const Loader = ({ size = 'medium', text = 'Loading...' }) => {
  const sizeClasses = {
    small: 'w-6 h-6',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  return (
    <div className="flex flex-col items-center justify-center space-y-3">
      {/* Spinning dots loader */}
      <div className="relative">
        <div className={`${sizeClasses[size]} relative`}>
          {/* Main spinning circle */}
          <div className="absolute inset-0 border-4 border-red-200 rounded-full animate-spin border-t-red-500"></div>
          
          {/* Inner pulsing dot */}
          <div className="absolute inset-2 bg-red-500 rounded-full animate-pulse"></div>
        </div>
      </div>
      
      {/* Loading text */}
      {text && (
        <p className="text-red-500 text-sm font-medium animate-pulse">
          {text}
        </p>
      )}
    </div>
  );
};

// Alternative Blinkit-style loader with multiple dots
export const BlinkitLoader = ({ text = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center space-y-4">
      {/* Three bouncing dots */}
      <div className="flex space-x-2">
        <div className="w-3 h-3 bg-red-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
        <div className="w-3 h-3 bg-red-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
        <div className="w-3 h-3 bg-red-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
      </div>
      
      {/* Loading text */}
      {text && (
        <p className="text-red-500 text-sm font-medium">
          {text}
        </p>
      )}
    </div>
  );
};

// Full screen loader overlay
export const FullScreenLoader = ({ text = 'Loading...' }) => {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
      <div className="text-center">
        {/* Smaller red spinning circle */}
        <div className="relative w-10 h-10 mx-auto mb-4">
          <div className="absolute inset-0 border-4 border-red-200 rounded-full animate-spin border-t-red-500"></div>
        </div>
        
        {/* Loading text */}  
      </div>
    </div>
  );
};

export default Loader;


// Add this new small inline loader component at the end of your Loader.js file

export const SmallInlineLoader = () => {
  return (
    <div className="inline-flex items-center ml-2">
      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};
